import React, { useEffect, useState } from 'react';
import { makeStyles, InputLabel } from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import { generateRegister } from '../utils';

const useStyles = makeStyles((theme) => ({
    inputClass: {},

    containerClass: {
        width: '100%',
        position: 'relative',
        '& .form-control': {
            backgroundColor: theme.palette.background.default,
            borderRadius: '0.625rem',
            paddingLeft: '3.75rem',
            padding: '1rem',
            height: '3rem',

            fontSize: '0.9rem',
            width: '100%',
            border: `1px solid ${theme.palette.background.default}`,
            color: theme.palette.text.primary,
            transition: '0.25s ease-in-out',
            '&:focus': {
                border: `1px solid ${theme.palette.primary.main}`,
                boxShadow: `0 0 3px ${theme.palette.primary.main}99`,
                backgroundColor: theme.palette.background.paper,
            },
            '&:Mui-error': {},
        },
    },
    buttonClass: {
        '&.flag-dropdown': {
            padding: '5px',
            backgroundColor: 'transparent',
            border: '1px solid transparent',
            '&.open': {
                border: `1px solid ${theme.palette.primary.main}`,
                boxShadow: `0 0 3px ${theme.palette.primary.main}99`,
                backgroundColor: theme.palette.background.paper,
            },
        },
        '& .selected-flag': {
            borderRadius: '6px',
            border: 'none',
            //@ts-ignore
            backgroundColor: theme.custom.color.bgGreyMid,
        },
    },
    dropdownClass: {},
}));

/**Form text box component */
const FormPhoneNumberBox = (props: ICommonFormProps) => {
    const classes = useStyles();
    const [value, setValue] = useState('');

    useEffect(() => {
        if (props.value) {
            onChange(props.value, {}, undefined, undefined);
        }
        //eslint-disable-next-line
    }, [props.value]);

    const onChange = (
        value: string,
        data: {},
        event?: React.ChangeEvent<HTMLInputElement>,
        formattedValue?: string,
    ) => {
        setValue(value);
        if (props.setValue) {
            props.setValue(props.keyName, value);
            if (props.formProps?.triggerValidationOnChange && props.triggerValidation) {
                props.triggerValidation(props.keyName);
            }
        }
    };

    return (
        <div>
            <InputLabel>{props.label}</InputLabel>
            <PhoneInput
                {...generateRegister(props)}
                containerClass={classes.containerClass}
                inputClass={classes.inputClass}
                buttonClass={classes.buttonClass}
                dropdownClass={classes.dropdownClass}
                disableSearchIcon={true}
                country={props.formProps?.country ?? 'gb'}
                inputProps={props.inputProperties}
                onChange={onChange}
                value={value}
                //When the input is guessing dial code, some countries have the same code, this allows you to override the guessing priority, or defaults to USA and Russia as highest prios
                priority={props.formProps?.priority ?? { ca: 1, us: 0, kz: 1, ru: 0 }}
                disableCountryGuess={props.formProps?.disableCountryGuess}
                data-component-name={'PhoneInput'}
            />
        </div>
    );
};

export default FormPhoneNumberBox;
